import React from 'react';
import { trackEvent } from '@/lib/analytics';

/**
 * Bouton "Continuer avec Google" (Emergent-managed Auth).
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleAuthButton({ label = 'Continuer avec Google', testid = 'google-auth-btn' }) {
    const launch = () => {
        trackEvent('google_signin');
        const redirectUrl = window.location.origin + '/auth/callback';
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <button
            type="button"
            onClick={launch}
            data-testid={testid}
            className="w-full h-12 inline-flex items-center justify-center gap-3 rounded-md border-2 border-foreground/15 bg-white hover:bg-surface-muted/50 text-foreground text-sm font-medium transition-colors shadow-sm hover:shadow-md"
        >
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path fill="#EA4335" d="M12 11v2.8h7.92c-.32 1.86-2.32 5.46-7.92 5.46-4.76 0-8.66-3.94-8.66-8.8 0-4.86 3.9-8.8 8.66-8.8 2.72 0 4.54 1.16 5.58 2.16l3.8-3.66C18.96 1.96 15.78.6 12 .6 5.78.6.74 5.66.74 12s5.04 11.4 11.26 11.4c6.5 0 10.8-4.56 10.8-11 0-.74-.08-1.3-.18-1.86L12 11Z"/>
                <path fill="#FBBC05" d="M3.42 7.06l3.16 2.32C7.4 7.34 9.56 5.7 12 5.7c1.66 0 3.16.58 4.34 1.7l3.18-3.1C17.42 2.4 14.86 1.2 12 1.2 7.2 1.2 3.06 4.16 1.18 8.36l2.24-1.3Z"/>
                <path fill="#34A853" d="M12 22.8c3.06 0 5.62-1.02 7.5-2.74l-3.46-2.84c-.94.66-2.18 1.12-4.04 1.12-3.08 0-5.7-2.04-6.62-4.84l-3.26 2.5C3.94 19.8 7.7 22.8 12 22.8Z"/>
                <path fill="#4285F4" d="M22.8 11c0-.74-.08-1.3-.18-1.86H12V13.8h6.18c-.3 1.5-1.18 2.78-2.5 3.62l3.46 2.84C20.78 18.6 22.8 15.42 22.8 11Z"/>
            </svg>
            {label}
        </button>
    );
}
